import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../../app.component';
import swal from 'sweetalert';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})

export class ErrorComponent implements OnInit {
  url;
  url_pdf;
  recaudadora;
  tipo;
  cuenta;
  lineaCaptura;
  idPagoRegresoBancoLog;
  tipoPeticion;
  transactionId;
  year_actual;
  EstatusMensaje;
  fecha_error;
  MensajeSweet;
  
  constructor(private route: ActivatedRoute, public global: AppComponent, private http: HttpClient) { 
    this.url = global.url;
    this.url_pdf = global.url_pdf;
    this.recaudadora = this.route.snapshot.paramMap.get('recaudadora');
    this.tipo = this.route.snapshot.paramMap.get('tipo');
    this.cuenta = this.route.snapshot.paramMap.get('cuenta');
    this.lineaCaptura = this.route.snapshot.paramMap.get('lineaCaptura');
    this.idPagoRegresoBancoLog = this.route.snapshot.paramMap.get('idPagoRegresoBancoLog');
    this.tipoPeticion = this.route.snapshot.paramMap.get('tipoPeticion');
    this.transactionId = this.route.snapshot.paramMap.get('transactionId');    
    this.consultar_error_santander_pagomovilapp();
  }

  ngOnInit(): void {
    /*
    if(this.global.web_status==='M'){
      this.global.mostrar = false;
      this.global.mostrar_mantenimiento = true;
    }
    */
    //this.global.validaHoraServicio();
  }//ngOnInit(): void {
  
  consultar_error_santander_pagomovilapp(){
    if(this.tipoPeticion == "app"){
      this.global.mostrar_layout = false;      
      document.querySelector('app-header').classList.add("hide");
      document.querySelector('app-footer').classList.add("hide");
    }else{
      this.tipoPeticion = "web";
      this.global.mostrar_layout = true;
      document.querySelector('app-header').classList.remove("hide");
      document.querySelector('app-footer').classList.remove("hide");
    }

    localStorage.clear();
    this.global.validaHoraServicio();
    const formData = new FormData();
    formData.append('recaudadora', this.recaudadora);
    formData.append('tipo', this.tipo);
    formData.append('cuenta', this.cuenta);
    formData.append('lineaCaptura', this.lineaCaptura);
    formData.append('idPagoRegresoBancoLog', this.idPagoRegresoBancoLog);

    //this.http.post(this.url+'consulta_adeudo', formData).subscribe((result: any) => {
    this.http.post(this.url+'consulta_error_mit', formData).subscribe((result: any) => {
      try {
        /*
        array('status' => TRUE,  'tipo'=>'1',  'message' => 'PAGO MIT RECHAZADO O DECLINADO',  'data' => ($data_api));
        array('status' => TRUE,  'tipo'=>'2',  'message' => 'LINEA DE CAPTURA NO LOCALIZADA',  'data' => ($data_api));
        array('status' => FALSE, 'tipo'=>'0',  'message' => 'ERROR PROCESAMIENTO 2',  'data' => ($data_api));
        array('status' => FALSE, 'tipo'=>'0',  'message' => 'ERROR PROCESAMIENTO 1',  'data' => ($data_api));
        array('status' => FALSE, 'tipo'=>'-1', 'message' => 'MANTENIMIENTO PROCESOS', 'data' => ($data_api));
        array('status' => FALSE, 'tipo'=>'-2', 'message' => 'PROCESANDO PAGOS',       'data' => ($data_api));
        array('status' => FALSE, 'tipo'=>'-3', 'message' => 'MANTENIMIENTO SISTEMAS', 'data' => ($data_api));
        */
        if (result.status === true) {
          this.EstatusMensaje = result.data.EstatusMensaje;
          this.fecha_error = result.data.fecha_error;
        } else {
          /*
          array('status' => TRUE,  'tipo'=>'1',  'message' => 'PAGO MIT RECHAZADO O DECLINADO',  'data' => ($data_api));
          array('status' => TRUE,  'tipo'=>'2',  'message' => 'LINEA DE CAPTURA NO LOCALIZADA',  'data' => ($data_api));
          array('status' => FALSE, 'tipo'=>'0',  'message' => 'ERROR PROCESAMIENTO 2',  'data' => ($data_api));
          array('status' => FALSE, 'tipo'=>'0',  'message' => 'ERROR PROCESAMIENTO 1',  'data' => ($data_api));
          array('status' => FALSE, 'tipo'=>'-1', 'message' => 'MANTENIMIENTO PROCESOS', 'data' => ($data_api));
          array('status' => FALSE, 'tipo'=>'-2', 'message' => 'PROCESANDO PAGOS',       'data' => ($data_api));
          array('status' => FALSE, 'tipo'=>'-3', 'message' => 'MANTENIMIENTO SISTEMAS', 'data' => ($data_api));
          */
          switch (result.tipo) {
            case '-1': //MANTENIMIENTO PROCESOS
            case '-3': //MANTENIMIENTO SISTEMAS
              //this.global.mostrar = false;
              this.global.mostrar_mantenimiento = true;
            break;
            
            case '-2': //PROCESANDO PAGOS
              //this.global.mostrar = false;
              this.global.mostrar_procesando_pagos_callback = true;
            break;

            default:
              this.MensajeSweet = result.message;
              swal("¡Error!", this.MensajeSweet, "error");
              
              this.global.mostrar = false;
            break;
          }

        }
      } catch (error) {
        
      }
    });
  }//consultar_error_santander_pagomovilapp(){

}